<template>
  <div>
    {{locale.admin_payment}}
  </div>
</template>

<script>
export default {
  name: 'Payment',
  props: [
    'locale'
  ]
}
</script>
